"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectPure = void 0;
var react_1 = __importDefault(require("react"));
exports.SelectPure = function (_a) {
    var inputRef = _a.inputRef, title = _a.title, defaultValue = _a.defaultValue, error = _a.error, children = _a.children, items = _a.items, rest = __rest(_a, ["inputRef", "title", "defaultValue", "error", "children", "items"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "input-title" }, title),
        react_1.default.createElement("select", __assign({ ref: inputRef, defaultValue: defaultValue }, rest, { className: error && 'has-error' }),
            !items && children,
            items &&
                items.map(function (i) { return (react_1.default.createElement("option", { value: i.id, key: i.id }, i.name)); })),
        error && react_1.default.createElement("div", { className: "error-input" }, error)));
};
//# sourceMappingURL=SelectPure.js.map